var _defs, _g, _text, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumEthBlast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-opacity: .2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-3, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #627eea;\n      }\n\n      .cls-3 {\n        fill-opacity: .6;\n      }\n\n      .cls-4 {\n        fill: #fcfc03;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1250,
    cy: 1250,
    r: 1250
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1288.9,312.5v693l585.7,261.7-585.7-954.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1288.9,312.5l-585.8,954.7,585.8-261.7V312.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1288.9,1716.2v470.9l586.1-810.9-586.1,340Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1288.9,2187.1v-470.9l-585.8-339.9,585.8,810.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1288.9,1607.3l585.7-340.1-585.7-261.6v601.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M703.1,1267.2l585.8,340.1v-601.6l-585.8,261.6Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2174.8,436.6l149.2-74.4,51.4-157.9-102.9-74.9h-685.1l-158.4,117.7h805.3l-42.8,132.4h-322.9l-31.1,96.8h322.9l-90.7,278.6,151.3-74.9,54-167.1-101.4-74.4,1-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1656.8,635.2l93.2-290.3-103.4-77.4-155.3,487.4h578.6l38.7-119.7h-451.8Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumEthBlast);
export default __webpack_public_path__ + "static/media/Ethereum ETH-blast.8ebeffdc173507f082cfd9b4eb81c098.svg";
export { ForwardRef as ReactComponent };